import Button from "components/Button/Button";
import { loaderColor } from "helpers/constants";
import { observer } from "mobx-react-lite";
import React from "react";
import Loader from "react-loader-spinner";
import UserStore from "stores/UserStore";
import VaultStore from "stores/VaultStore";
import { PoolData } from "types";

const boosts = [
  { level: 1, p: "5" },
  { level: 2, p: "15" },
  { level: 3, p: "30" },
  { level: 4, p: "60" },
];

type Props = {
  pool: PoolData;
};

const Multipliers = observer(({ pool }: Props) => {
  const multiplierTokenBalance = UserStore.balances.get("RAM");
  const allowances = UserStore.allowances.get("Vault");
  const userInfo = VaultStore.userPoolData.get(pool.poolId);
  // No data loaded? Spin it.
  if (!allowances || !userInfo) return <Loader type="Bars" color={loaderColor} />;
  const { poolId } = pool;
  const { boostCosts, boostLevel } = userInfo;
  // Check allowance for this specific pool token
  const allowance = allowances?.find((allowance) => allowance.tokenName === "RAM");
  const hasAllowance = allowance && allowance.hasAllowance;
  return (
    <div className="section-boosts">
      <div className="section-asset-balance top-level-item">
        <span className="asset-balance-text">wallet</span>
        <div className="section-item-value">
          {multiplierTokenBalance ? multiplierTokenBalance.toFixed(3) : 0.0}
          <span className="asset-balance-text">RAM</span>
        </div>
      </div>
      <div className="boost-buttons">
        {hasAllowance ? (
          <>
            {boosts.map(({ level, p }, index: number) => {
              const tooPoor = multiplierTokenBalance ? multiplierTokenBalance < boostCosts![index] : false;
              const hasLevel = level <= boostLevel!;
              return (
                <Button
                  key={`boost-button-${level}`}
                  type="positive"
                  className={`boost-button top-level-item ${tooPoor && "disabled"} ${hasLevel && "has-level"}`}
                  onClick={() => VaultStore.purchase(poolId, level)}
                >
                  {!hasLevel ? (
                    <>
                      {p}% multi <span className="boost-cost">(-{boostCosts![index]} RAM)</span>
                    </>
                  ) : (
                    <div>Bought! {level === boostLevel && <b style={{ fontSize: "16px" }}>{p}%</b>}</div>
                  )}
                </Button>
              );
            })}
          </>
        ) : (
          <>
            {" "}
            <Button
              type="positive"
              className="interaction-button top-level-item approval-button"
              onClick={() => UserStore.getAllowance("RAM", "Vault")}
            >
              Approve RAM before you can boost
            </Button>
          </>
        )}
      </div>
    </div>
  );
});

export default Multipliers;
